import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Placeholder from 'components/consumer/Placeholder';
import IconClose from 'components/icons/iconClose';
import { colorGrayLight1 } from 'styles/layout/colors';
const PDPDecideLaterPromoUI = t0 => {
  const $ = _c(23);
  const {
    heading,
    subheading,
    buttonText,
    loading: t1,
    onButtonClick,
    onClose
  } = t0;
  const loading = t1 === undefined ? true : t1;
  const t2 = loading === false;
  let t3;
  if ($[0] !== t2) {
    t3 = classNames("items-center bg-yellow-light rounded text-gray-dark flex justify-between px-6 py-4 relative max-[767px]:items-start max-[767px]:flex-col", {
      "animate-fade-in-ease": t2
    });
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== heading) {
    t4 = <div className="text-base font-bold">{heading}</div>;
    $[2] = heading;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== subheading) {
    t5 = <div className="text-xs">{subheading}</div>;
    $[4] = subheading;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = <div className="pr-4 max-[767px]:mb-4">{t4}{t5}</div>;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== buttonText || $[10] !== onButtonClick) {
    t7 = <div className="PDPDecideLaterPromoUI__button-wrapper"><button className="text-sm font-bold border-0 rounded-sm text-white px-3 py-2 hover:cursor-pointer hover:text-white max-[767px]:px-8 max-[767px]:py-[.7rem] bg-gray-dark" type="button" onClick={onButtonClick}>{buttonText}</button></div>;
    $[9] = buttonText;
    $[10] = onButtonClick;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <IconClose color={colorGrayLight1} height={9} width={9} />;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== onClose) {
    t9 = <button className="[background:none] border-0 px-2 py-[5px] absolute right-0 top-0 hover:cursor-pointer" type="button" onClick={onClose}>{t8}</button>;
    $[13] = onClose;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t3 || $[16] !== t6 || $[17] !== t7 || $[18] !== t9) {
    t10 = <div className={t3}>{t6}{t7}{t9}</div>;
    $[15] = t3;
    $[16] = t6;
    $[17] = t7;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== loading || $[21] !== t10) {
    t11 = <Placeholder loading={loading} type="rect" className="!bg-yellow-light rounded min-h-[73px] max-[767px]:min-h-[122px]">{t10}</Placeholder>;
    $[20] = loading;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
};
PDPDecideLaterPromoUI.propTypes = {
  heading: PropTypes.string,
  subheading: PropTypes.string,
  buttonText: PropTypes.string,
  loading: PropTypes.bool,
  onButtonClick: PropTypes.func,
  onClose: PropTypes.func
};
export default PDPDecideLaterPromoUI;